import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Field from './RelayDetailField';

/**
 * POM-6099 story 8. Tracking arriving does NOT move the status: a relayed order's lifecycle is
 * PENDING -> TRANSFERRED and nothing after it, because POM neither fills nor ships the order. So
 * this is a data panel, not a state, and the Status field stays TRANSFERRED once tracking lands.
 *
 * The ABSENT case is spelled out rather than left as three blanks. An empty panel reads as a data
 * bug and generates a ticket; an order Diamond has not reported on yet is not stuck, and the
 * operator needs to be told which of the two they are looking at.
 */
const RelayShipmentPanel = ({ order }) =>
  order.trackingNumber ? (
    <Box sx={{ mt: 2 }}>
      <Typography variant='subtitle2' gutterBottom>
        Shipment
      </Typography>
      <Grid container spacing={2}>
        <Field label='Tracking Number' value={order.trackingNumber} />
        <Field label='Carrier' value={order.carrier} />
        {/* TEXT, NOT A LINK, and this is a departure from the six existing tracking links in this
            portal for a reason worth stating. Every one of those builds its href from
            `getTrackingInfo`, which DERIVES the URL from the tracking number via a carrier map —
            so the href is PerfectRx-constructed. This URL is VENDOR-SUPPLIED, which is a different
            trust class: rendering it as an anchor makes an admin console follow a third party's
            redirect. A real Quello delivery also carried UNENCODED SPACES in it, so it is not a
            well-formed URL either — `new URL()` would silently percent-encode them and hand the
            DOM a different string than the one stored here. */}
        <Field label='Tracking URL' value={order.trackingUrl} />
      </Grid>
    </Box>
  ) : (
    <Alert severity='info' sx={{ mt: 2 }}>
      Diamond has not reported a shipment for this order yet, so there is no tracking number,
      carrier or tracking URL to show. This is not an error — a relayed order is complete from
      PerfectRx&apos;s side once Diamond accepts it.
    </Alert>
  );

RelayShipmentPanel.propTypes = {
  order: PropTypes.shape({
    trackingNumber: PropTypes.string,
    trackingUrl: PropTypes.string,
    carrier: PropTypes.string,
  }).isRequired,
};

export default RelayShipmentPanel;
